import { useState, useCallback, useEffect } from 'react';
import Typography from '@mui/joy/Typography';
import Tooltip from '@mui/joy/Tooltip';
import { timeDuration } from 'utils/misc';
import { JoyTypeLevels } from '../types';
import { ColorPaletteProp } from '@mui/joy';

export default function DateUI({ dateString, na="..." } : { dateString : string|null|undefined, na?: string }) {
	if (!dateString) return <Typography>{na}</Typography>
    const d = new Date(dateString);
	const time = Intl.DateTimeFormat('en-US', {
		hour: 'numeric',
		minute: 'numeric',
		hour12: true }).format(d)
	return <Typography>{d.toLocaleDateString() + " " + time}</Typography>
}



export function TimeUI({ ts, na="...", showDate=undefined  } : { ts : string | null, na?: string, showDate?: boolean }) {
/** Show the time if it's today, otherwise show the date AND time.
Use DateOrTime if you want to hide the time when it's a date.
 */
	if (!ts) return <Typography>{na}</Typography>
    const d = new Date(ts);
	const time = Intl.DateTimeFormat('en-US', {
		hour: 'numeric',
		minute: 'numeric',
		hour12: true }).format(d)

    if((showDate === undefined) && (d.toLocaleDateString() !== new Date().toLocaleDateString())) {
        showDate = true;
    }

	return (
        <Tooltip arrow title={`${d.toLocaleDateString()} ${time}`}>
            <Typography>{(showDate ? d.toLocaleDateString() + " " : '') + time}</Typography>
        </Tooltip>
    );
}



export function DateOrTime({ ts, na="...", intro=""  } : { ts : string | null, na?: string, intro?: string }) {
    /**
        * If the date is today, show the time, otherwise show the date
        */
	if (!ts) return <Typography>{na}</Typography>
    const d = new Date(ts);
	const time = Intl.DateTimeFormat('en-US', {
		hour: 'numeric',
		minute: 'numeric',
		hour12: true }).format(d)

    const str = ((d.toLocaleDateString() !== new Date().toLocaleDateString()) ?
        d.toLocaleDateString() : time);


	return (
        <Tooltip arrow title={`${intro} ${d.toLocaleDateString()} ${time}`}>
            <Typography>{str}</Typography>
        </Tooltip>
    );
}

export function DurationSeconds({ seconds, level="inherit", color=undefined } : { seconds : number, level?: JoyTypeLevels, color?: ColorPaletteProp | undefined }) {
    return <Typography
               color={color}
               level={level} >{
                   timeDuration(seconds)
               }</Typography>
}


export function Duration({ start, end, level="inherit", verb=null, minimum=0 } : { start : string, end : string|null, level?: JoyTypeLevels, verb?: string|null, minimum?: number }) {
    const [ diff, setDiff ] = useState(0);
    const [running, setRunning] = useState(false);
    const [runningId, setRunningId] = useState(0);

    const int_start = new Date(start).getTime();

    const updateDiff = useCallback(() => {
        const int_end = end ? new Date(end).getTime() : new Date().getTime();
        // if(end) {
        // // console.log("int_end  ", int_end, new Date(end));
        // // console.log("int_start", int_start, new Date(start));
        // //     console.log('     diff', int_end - int_start);
        // }
        if (int_end && int_start) {
            setDiff(int_end - int_start);
        }
    }, [int_start, setDiff, end]);


    useEffect(() => {
        if (running) {
            return undefined;
        }
        setRunning(true);
        updateDiff();
        if (!end) {
            setRunningId(window.setInterval(() => {
                updateDiff();
            }, 1_000));

            return () => {
                if (runningId) {
                    window.clearInterval(runningId);
                    setRunningId(0);
                }
            }
        }

    }, [updateDiff, setRunningId, runningId, setRunning, running]);

    const dur = Math.max(Math.floor(diff / 1_000), minimum * 60);

    return <Tooltip arrow title={verb ? `${verb} ${ timeDuration(dur) } ago` : null}>
               <Typography level={level} >{ timeDuration(dur) }</Typography>
    </Tooltip>
}
